import { useI18n } from "../../utils/translate/i18n/useI18n";

export default function HearingTestTips() {
  const { t } = useI18n();
  return (
    <div className="d-flex justify-content-center mt-4">
      <div className="d-flex flex-column gap-2 text-start">
        <div>🎧 {t("Użyj słuchawek dobrej jakości, najlepiej nausznych")}</div>
        <div>🤫 {t("Zadbaj o ciszę w otoczeniu")}</div>
        <div>🔊 {t("Ustaw głośność słuchawek na 50%")}</div>
        <div>🔕 {t("Wyłącz komunikatory oraz inne takie aplikacje")}</div>
      </div>
    </div>
  );
}
